import { useNavigate } from 'react-router-dom';
import './BackButton.css'; // 선택사항

export default function BackButton({page, handlekeywordBack, handlenoticedeleteBack}) {
    const navigate = useNavigate();
    return (
        <button className="back-button" 
        onClick={() =>{
            if(page=='keywordManage'){
                handlekeywordBack();
            }
            else if(page=='noticeDelete'){
                handlenoticedeleteBack();
            }
            else navigate(-1)}}>
            ← 돌아가기
        </button>
    );
}